import { ReactNode, useEffect } from 'react';
import { useGlobalStoreShallow } from 'src/store/globalStore';

import { StepControl } from '@speeki/global-ui-components';

import { LayoutWrapper } from '@components/ions/layouts';

import { useResponsive } from '@utils/hooks/useResponsive';
import { useTenantAvatar } from '@utils/hooks/useTenantAvatar';

import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';
import {
    ConversationSidebar,
    SidebarProps,
} from '@domains/new-conversation/molecules/ConversationSidebar/ConversationSidebar';

import {
    ContentInnerWrapper,
    ContentWrapper,
    LayoutContent,
    MobileMenuInnerWrapper,
    MobileMenuWrapper,
    SidebarWrapper,
} from './ConversationLayout.styled';

interface LayoutSidebarProps extends Omit<SidebarProps, 'children'> {
    buttons?: JSX.Element;
}

interface ConversationLayoutProps {
    children: ReactNode;
    className?: string;
    footer?: JSX.Element;
    header?: JSX.Element;
    sidebarProps: LayoutSidebarProps;
}

export const ConversationLayout = ({
    children,
    className,
    footer,
    header,
    sidebarProps,
}: ConversationLayoutProps) => {
    const { buttons, currentStep, preventionModalActive } = sidebarProps;

    const { setBlockScroll } = useGlobalStoreShallow(['setBlockScroll']);

    const isMd = useResponsive('md');
    const isGuest = useReactiveVar(authVar).isGuest;

    useTenantAvatar({});

    useEffect(() => {
        setBlockScroll(isMd);

        return () => {
            setBlockScroll(false);
        };
    }, [isMd]);

    return (
        <LayoutWrapper className={className}>
            <LayoutContent>
                <ContentWrapper id="conversation-content">
                    <ContentInnerWrapper>{children}</ContentInnerWrapper>
                </ContentWrapper>

                <SidebarWrapper>
                    <ConversationSidebar
                        currentStep={currentStep}
                        preventionModalActive={preventionModalActive}
                    >
                        {buttons}
                    </ConversationSidebar>
                    {header}
                </SidebarWrapper>

                {isMd && (
                    <MobileMenuWrapper>
                        {footer}
                        <MobileMenuInnerWrapper>
                            <StepControl
                                activeStep={currentStep}
                                length={isGuest ? 4 : 3}
                                testId="epZ9tqE"
                                variant="dark"
                            />
                            {buttons}
                        </MobileMenuInnerWrapper>
                    </MobileMenuWrapper>
                )}
            </LayoutContent>
        </LayoutWrapper>
    );
};
